module.exports = __webpack_public_path__ + "img/sup_deposit_vega4.db7972e3.jpg";